import en from "./en"

const ar = {
    ...en,
    next: 'التالي',
    error: 'خطأ',
    notFound: '404 غير موجود.',
    m: {
        ...en.m,
        loginTitle: 'افتح بنك الطاقة الخاص بك',
        phonePlaceholder: 'رقم الجوال',
        or: 'أو',
        emailLogin: 'المتابعة عبر البريد الإلكتروني',
        phoneLogin: 'المتابعة عبر الهاتف',
        quickLogin: 'المتابعة كضيف',
        loginRequiredTip: 'يرجى تسجيل الدخول أولاً',
        continueGoogle: 'المتابعة عبر Google',
        continueApple: 'المتابعة عبر Apple',
        langBoxTitle: 'اختر اللغة',
        policyAndTerms: "أوافق على <a href='[termsOfServiceUrl]'>شروط الخدمة</a> و<a href='[privacyPolicyUrl]'>سياسة الخصوصية</a> الخاصة بـ [brandName].",
        verifyTitle: 'أدخل الرمز المكوّن من 6 أرقام المرسل إلى [phonenumber]',
        verifyEmailTitle: 'أدخل الرمز المكوّن من 6 أرقام المرسل إلى [email]',
        paymentTitle: 'افتح بنك الطاقة الخاص بك',
        resend: 'إعادة إرسال الرمز',
        emailAddress: 'البريد الإلكتروني',
        registerTitle: 'أدخل معلوماتك.',
        fNameInput: 'الاسم الأول',
        lNameInput: 'اسم العائلة',
        emailInput: 'البريد الإلكتروني',
        birthInput: 'تاريخ الميلاد',
        postCodeInput: 'الرمز البريدي',
        billingRate: 'التعرفة',
        unpaidPopupSubtitle: 'لديك طلب غير مدفوع',
        unpaidPopupContent: 'لديك طلب غير مدفوع. يرجى إتمام الدفع قبل الاستئجار مرة أخرى.',
        payNow: 'ادفع الآن',
        paymentSuccessfulSubtitle: 'تم الدفع بنجاح!',
        paymentSuccessfulContent: 'يمكنك متابعة الاستئجار الآن!',
        goToRental: 'الانتقال إلى الاستئجار',
        repaymentTitle: 'دفع الطلب',
        rentalInformation: 'معلومات الاستئجار',
        selectPayMethod: 'اختر طريقة الدفع',
        applePay: 'Apple Pay',
        googlePay: 'Google Pay',
        balance: 'الرصيد',
        creditOrDebit: 'بطاقة ائتمان أو خصم',
        free: 'مجاني',
        pay: 'ادفع',
        confirm: 'تأكيد',
        savePay: 'حفظ والدفع',
        recharge: 'شحن الرصيد',
        balancePopupTitle: 'شحن الرصيد',
        topUpRent: 'شحن واستئجار',
        bindPopupTitle: 'إضافة بطاقة دفع',
        preparingTitle: 'جارٍ تجهيز الشاحن',
        preparingSubtitle: 'يتم إخراج بنك الطاقة. يرجى الانتظار.',
        preparingStationBusySubtitle: 'بانتظار اكتمال إخراج بنك الطاقة السابق. يرجى الانتظار.',
        rentalSuccessTitle: 'نجاح!',
        rentalFailTitle: 'فشل!',
        rentalSuccessSubtitle: 'شكرًا لاستخدامك [brandName]. يرجى إعادة بنك الطاقة بعد الانتهاء.',
        rentalNumber: 'رقم الطلب',
        rentalTime: 'وقت الاستئجار',
        rentalLocation: 'مكان الاستئجار',
        returnTime: 'وقت الإرجاع',
        returnLocation: 'مكان الإرجاع',
        rentalDuration: 'مدة الاستئجار',
        totalAmount: 'المبلغ الإجمالي',
        paidAmount: 'المبلغ المدفوع',
        unpaidAmount: 'المبلغ المستحق',
        currentFee: 'التكلفة التقديرية',
        rentalDetails: 'تفاصيل الاستئجار',
        rentingTitle: 'أنت تستخدم الآن بنك طاقة من [brandName]',
        keepIt: 'هل تريد الاحتفاظ به؟ اشترِ الآن!',
        findNearby: 'اعثر بسهولة على محطات الإرجاع القريبة—حمّل تطبيقنا الآن!',
        orderDeatil: 'تفاصيل الطلب',
        mapMenuHelp: 'المساعدة',
        helpTitle: 'المساعدة',
        helpReportProblem: 'الإبلاغ عن مشكلة',
        helpChatWithUs: 'تحدث معنا',
        chatWithUsTitle: 'تحدث معنا',
        chatContactMethods: 'طرق التواصل',
        reportProblemTitle: 'الإبلاغ عن مشكلة',
        reportDeviceCode: 'رمز الجهاز',
        reportScanQrCode: 'مسح رمز QR الخاص بالجهاز',
        reportDeviceCodePlaceholder: 'امسح رمز QR الخاص بالجهاز أو أدخل معرف الجهاز',
        reportProblemType: 'المشكلة',
        reportProblemTypeAria: 'نوع المشكلة',
        reportProblemPowerBankNotEjected: 'لم يتم إخراج بنك الطاقة',
        reportProblemCannotChargeDevice: 'لا يشحن الجهاز',
        reportProblemOrderNotEnded: 'لم ينتهِ الطلب',
        reportProblemCableDamagedLost: 'الكابل تالف/مفقود',
        reportProblemOther: 'أخرى',
        reportTakePicture: 'رفع صورة',
        reportChooseOrTakePicture: 'رفع صورة',
        reportRemovePicture: 'إزالة الصورة',
        reportDescribeProblem: 'صف المشكلة',
        reportDescriptionPlaceholder: 'يرجى إدخال وصف',
        reportFieldRequired: 'مطلوب',
        reportFieldOptional: 'اختياري',
        reportSubmit: 'إرسال',
        reportSubmittedSuccessfully: 'تم الإرسال بنجاح',
        mapMenuYourInfo: 'بياناتك',
        profileTitle: 'الملف الشخصي',
        profileSave: 'حفظ',
        profileNoChanges: 'يرجى تحديث حقل واحد على الأقل بقيمة.',
        profileDeleteAccount: 'حذف',
        profileDeleteConfirmTitle: 'حذف الحساب؟',
        profileDeleteConfirmContent: 'سيتم حذف جميع بيانات حسابك نهائيا، وسيتم تسجيل خروجك بعد الحذف.',
        serverErrorTitle: 'خطأ في الخادم',
        serverError: 'حدث خطأ في الخادم. يرجى المحاولة لاحقًا أو التواصل مع الدعم.',
        stationNotFoundTitle: 'لم يتم العثور على المحطة',
        stationNotFound: 'يرجى محاولة مسح الرمز مرة أخرى.',
        stationOfflineTitle: 'المحطة غير متصلة',
        stationOffline: 'يبدو أن الجهاز غير متصل. تحقّق من توصيل كابل الطاقة أو جرّب فصله وإعادة توصيله.',
        totalCost: 'التكلفة الإجمالية',
        returnSuccessTitle: 'تم الإرجاع بنجاح!',
        returnSuccessSubtitle: 'شكرًا لاستخدامك [brandName].',
        rentAgain: 'استئجار مرة أخرى',
        guestLoginTips: 'تتطلب هذه الميزة حساباً رسمياً. وضع الضيف غير متاح. هل ترغب في تسجيل الدخول؟',
    },
    tMsg: {
        ...en.tMsg,
        agreePolicy: 'وافق على سياسة الخصوصية والشروط الخاصة بـ [brandName]',
        errorTel: 'يرجى إدخال رقم هاتف صحيح',
        sendSuccess: 'تم الإرسال بنجاح',
        inputAll: 'يرجى إدخال جميع المعلومات المطلوبة',
        wrongEmail: 'تنسيق البريد الإلكتروني غير صحيح',
        wrongBirthday: 'يرجى إدخال تاريخ ميلاد صحيح',
        initPayFail: 'فشل تهيئة الدفع',
    },
    bRule: {
        ...en.bRule,
        priceTimeDesc: '/[price_time] دقيقة',
        freeTimeDesc: 'مجاني لمدة [free_time] دقيقة',
        flatFeeDesc: 'رسوم ثابتة [flat_fee] لأول [flat_fee_time] دقيقة',
        lowLimitDesc: 'الحد الأدنى للرسوم: [low_limit]',
        topLimitDesc: 'الحد الأقصى للرسوم اليومية: [top_limit]',
        preAuthDesc: 'سيتم تفويض [pre_auth_amount] مسبقًا على وسيلة الدفع الخاصة بك',
        depositDesc: 'إذا لم تتم الإعادة خلال [maximum_rental_time] ساعة، سيتم خصم [deposit] وسيصبح بنك الطاقة ملكًا لك',
        ruleError: 'خطأ في التعرفة',
        noneRuleDesc: 'لا توجد تعرفة',
    },
    eMsg: {
        ...en.eMsg,
        500: 'خطأ في الشبكة',
        1000: 'فشلت العملية',
        30022: 'يرجى إدخال تنسيق رقم الهاتف الصحيح',
        30128: 'تم إرسال رمز التحقق مرات كثيرة. حاول لاحقًا',
        30129: 'فشل إرسال رمز التحقق',
        30101: 'رمز التحقق غير صحيح أو منتهي الصلاحية',
        50101: 'لم يتم العثور على المحطة',
        50105: 'لديك طلب غير مسدد',
        50106: 'المحطة غير متصلة',
        50108: 'لا توجد بنوك طاقة متاحة حاليًا',
        50109: 'فشل إخراج بنك الطاقة. يرجى المحاولة مرة أخرى',
        50113: 'هذه المحطة تتطلب حسابًا',
        50114: 'لا يمكن للضيوف استخدام هذه الميزة. يرجى تسجيل الدخول',
        50111: 'وسيلة دفع غير صالحة',
        50305: 'وسيلة دفع غير صالحة',
        80411: 'فشل إضافة وسيلة الدفع',
        50103: 'لا توجد وسيلة دفع صالحة',
        50206: 'فشل دفع الطلب السابق. يرجى تحديث وسيلة الدفع',
    }
}

export default ar
